import React, {useEffect, useRef} from 'react';
import InputDateTime from "../../../../components/input/input-datetime.jsx";
import SelectComponent from "../../../../components/select/select-component.jsx";
import useFetchOptions from "./hooks/use-fetch-options.js";
import InputRadio from "../../../../components/input/input-radio.jsx";
import HourTypeInput from "../../../../components/reports/time-period-input/hour-type-input.jsx";
import {minMenuHeight} from "../../../../components/reports/report-menu/menu.jsx";

const Filters = ({ setFilters, filters }) => {
    const initialized = useRef(false);
    const { capturePlacesOptions } = useFetchOptions();

    useEffect(() => {
        if (!initialized.current && capturePlacesOptions?.length) {
            setFilters(prev => ({...prev, capture_places: capturePlacesOptions}));
            initialized.current = true;
        }
    }, [capturePlacesOptions]);

    return (
        <>
            <div className={`mb-2 ${minMenuHeight}`}>
                <form className={'space-y-4'}>

                    <InputDateTime
                        id="dtStart"
                        label="Data inicial *"
                        selected={filters.dtStart ? new Date(filters.dtStart) : null}
                        onChange={(date) => setFilters(prev => ({ ...prev, dtStart: date }))}
                        classNameWrapper={"w-full"}
                        dateFormat="L"
                    />

                    <InputDateTime
                        id="dtEnd"
                        label="Data final *"
                        selected={filters.dtEnd ? new Date(filters.dtEnd) : null}
                        onChange={(date) => setFilters(prev => ({ ...prev, dtEnd: date }))}
                        classNameWrapper={"w-full"}
                        dateFormat="L"
                    />

                    <HourTypeInput filters={filters} setFilters={setFilters} hasDateType={true}></HourTypeInput>

                    <SelectComponent
                        label="Pontos de coleta *"
                        isMulti={true}
                        wrapValues={true}
                        options={capturePlacesOptions}
                        value={filters.capture_places}
                        onChange={(value) => setFilters(prev => ({...prev, capture_places: value}))}
                        instanceId="capture_places"
                        classNameWrapper={"w-full"}
                        isClearable={true}
                    />

                    <div className={"ml-1 mb-4"}>
                        <InputRadio
                            name="search-type"
                            id="search-type-pcl"
                            label="Agrupar por ponto de coleta"
                            value="pcl"
                            checked={filters.searchType === 'pcl'}
                            onChange={(e) => setFilters(prev => ({...prev, searchType: e.target.value}))}
                        />
                    </div>

                    <div className={"ml-1"}>
                        <InputRadio
                            name="search-type"
                            id="search-type-lane"
                            label="Agrupar por câmera"
                            value="lane"
                            checked={filters.searchType === 'lane'}
                            onChange={(e) => setFilters(prev => ({...prev, searchType: e.target.value}))}
                        />
                    </div>

                </form>
            </div>
        </>
    );
};

export default Filters;